import InformationIcon from '@atlaskit/icon/core/information';
import * as React from 'react';

export function SvgInfoFill() {
  return <InformationIcon label="" testId="ads-refreshed-icon" />;
}
